const editImage = {
    isEditImage: false,
    isShowAnimate:0
};

export default editImage;
